// extracted by mini-css-extract-plugin
module.exports = {"overlay-styles":"modal_overlay-styles__eDVHi","modal-styles":"modal_modal-styles__3-D6X","button-close":"modal_button-close__12eFN"};